module.exports = __webpack_public_path__ + "img/floors.d452396e.svg";